'use strict';

/**
 * Servicio centralizado del modo iframe Mi Docta.
 *
 * Sirve para que TODA la app (interceptors, header, componentes de turnos, utils)
 * pueda preguntar "¿estoy en iframe Mi Docta?" y mantener al usuario adentro
 * sin escapes a CiDi/VeDi/logout/apps externas.
 *
 * Persistencia: sessionStorage[turnero_modoClienteMiDocta] = '1' mientras dure
 * la pestaña. Lo activa el componente coMiDoctaIframeComponent al ingresar.
 * No queda en localStorage para no contaminar otras pestañas/sesiones.
 */
angular.module('TurneroApp').service('miDoctaModoService', [
    '$rootScope',
    '$window',
    'TurneroAppConstant',
    function ($rootScope, $window, TurneroAppConstant) {
        var KEY = (TurneroAppConstant && TurneroAppConstant.integracionMiDocta && TurneroAppConstant.integracionMiDocta.sessionStorageKeyModoCliente)
            || 'turnero_modoClienteMiDocta';
        var QUERY = (TurneroAppConstant && TurneroAppConstant.integracionMiDocta && TurneroAppConstant.integracionMiDocta.queryParamModoCliente)
            || 'modoClienteMiDocta';

        /** True cuando la sesión actual proviene del iframe Mi Docta. */
        this.estaActivo = function () {
            try {
                return sessionStorage.getItem(KEY) === '1';
            } catch (e) {
                return false;
            }
        };

        /** Activa el modo (ya lo hace el componente del iframe; expuesto para reusar). */
        this.activar = function () {
            try { sessionStorage.setItem(KEY, '1'); } catch (e) { }
            $rootScope.modoRestringidoClienteMiDocta = true;
        };

        /** Desactiva el modo cuando el usuario entra a Turnero por el flujo normal. */
        this.desactivar = function () {
            try { sessionStorage.removeItem(KEY); } catch (e) { }
            $rootScope.modoRestringidoClienteMiDocta = false;
        };

        /**
         * Devuelve la URL del iframe de Mi Docta para mostrar el cartel de error.
         * Centraliza el destino para que cualquier interceptor/componente devuelva al iframe
         * en lugar de redirigir a CiDi/VeDi externos.
         */
        this.urlIframeError = function (codigo) {
            var host = $rootScope.urlHostServer || ($window.location.protocol + '//' + $window.location.host + '/');
            var cod = codigo || 'sesion-expirada';
            return host + 'integracion/mi-docta?error=' + encodeURIComponent(cod);
        };

        /**
         * Devuelve una URL interna del SPA (turnos/...) preservando ?modoClienteMiDocta=1.
         * Útil para reemplazar redirects del tipo `$window.location.href = '/turnos'`
         * sin perder el modo en la próxima carga.
         */
        this.urlInternaConModo = function (path) {
            var p = path || '/turnos';
            if (!this.estaActivo()) return p;
            var sep = p.indexOf('?') === -1 ? '?' : '&';
            return p + sep + QUERY + '=1';
        };

        /**
         * Redirige a la URL conservando el modo iframe si corresponde.
         * Para casos donde igualmente hay que recargar la SPA (errores duros).
         */
        this.redirigirInterno = function (path) {
            $window.location.href = this.urlInternaConModo(path);
        };

        /**
         * Redirige a CiDi/VeDi SOLO si NO estamos en modo iframe.
         * Si estamos en iframe, vuelve al cartel del iframe en vez de salir.
         */
        this.redirigirExternoCidiOIframe = function (urlExternaCiDi) {
            if (this.estaActivo()) {
                $window.location.href = this.urlIframeError('sesion-expirada');
            } else {
                $window.location.href = urlExternaCiDi;
            }
        };
    }
]);



// WEBPACK FOOTER //
// ./app/shared/integracionMiDocta/miDoctaModoService.js